import './header';
import './footer';
import './newsletter';

new Vue({
  delimiters: ['[[', ']]'], // change because vue and django using the same args 
  el: '#footer',
  methods: {
    cartPreview() {
      // Constantes globais
      const CONFIG = {
        API_HEADERS: { 'Content-Type': 'application/json' },
        CART_ENDPOINT: '/api/front/cart/items/?version=2',
        SELECTORS: {
          cartPreview: '.cart-preview',
          shippingOverlay: '.cart-preview__shipping--overlay',
          shipping: '.cart-preview__shipping',
          shippingClose: '.cart-preview__shipping--close',
          itemsList: '.cart_preview-items',
          subtotal: '.cart-preview__sub-total--value',
          discounts: '.cart-preview__discounts--value',
          total: '.cart-preview__total--value',
          counters: '.quant_itens_carrinho',
          footer: '.cart-preview__footer',
          footerUtils: '.cart-preview__footer-utils',
          openUtils: '.open-utils',
          couponInput: '#appendedInputButton',
          removeCoupon: '#removeCoupon',
          shippingForm: '#js_form_shipping_cep_cart',
          cepInput: '#js_cep_input_cart',
          shippingList: '.cart-preview__shipping__list',
          selectedShipping: '.selected-shipping',
          // Seletores para a barra de progresso do frete grátis
          freeShippingBar: '.cart-preview-free-shipping__bar--percent',
          freeShippingValueFrom: '.cart-preview-free-shipping__value-from',
          freeShippingValueTo: '.cart-preview-free-shipping__value-to',
          freeShippingTip: '.cart-preview-free-shipping__tip'
        }
      };
      const handleZipCode = (event) => {
        let input = event.target;
        input.value = zipCodeMask(input.value);
      }
  
      const zipCodeMask = (value) => {
        if (!value) return "";
        value = value.replace(/\D/g, '');
        value = value.replace(/(\d{5})(\d)/, '$1-$2');
        return value;
      }
      const cepInput = document.querySelector('.cart-preview #js_form_shipping_cep_cart');
      if (cepInput) {
        cepInput.addEventListener('keyup', handleZipCode);
      }
  
  
      // Funções utilitárias
      const utils = {
        formatCurrency: value => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value),
  
        toggleClasses: (selectors, className, add = true) => {
          selectors.forEach(selector => $(selector)[add ? 'addClass' : 'removeClass'](className));
        },
  
        ajaxRequest: (method, url, data, headers = CONFIG.API_HEADERS) => {
          return $.ajax({
            type: method,
            url,
            headers,
            dataType: 'json',
            data: typeof data === 'object' ? JSON.stringify(data) : data
          });
        },
  
        updateFooterUtilsHeight: (first) => {
          const utils = document.querySelector(CONFIG.SELECTORS.footerUtils);
          if (utils) {
            utils.querySelectorAll('li').forEach(li => {
              const append = li.querySelector('.input-append');
              if (append) {
                const form = append.querySelector('form');
                const list = append.querySelector('.cart-preview__shipping__list');
  
                let totalHeight = 0;
                if (form) totalHeight += form.getBoundingClientRect().height;
                if (list) {
                  if (list.children.length === 1) {
                    totalHeight += 85;
                  } else if (list.children.length > 1) {
                    totalHeight += 145;
                  }
                }
  
                append.style.height = `${totalHeight + 20}px`; // +20px de espaçamento
              }
  
              if (first) {
                li.classList.add('active');
              }
            });
          }
        },
  
        // Função para atualizar a barra de progresso do frete grátis
        updateFreeShippingProgress: (currentValue, targetValue, freeShippingLabel, freeShippingLabelSuccess) => {
          const { SELECTORS } = CONFIG;
          
          // Converter valores para números
          const current = parseFloat(currentValue) || 0;
          const target = parseFloat(targetValue) || 0;
          
          // Calcular a porcentagem
          let percentage = 0;
          if (target > 0) {
            percentage = Math.min((current / target) * 100, 100);
          }
          
          // Atualizar a barra de progresso
          const progressBar = document.querySelector(SELECTORS.freeShippingBar);
          if (progressBar) {
            progressBar.style.width = `${percentage}%`;
          }
          
          // Atualizar os valores exibidos
          const valueFrom = document.querySelector(SELECTORS.freeShippingValueFrom);
          const valueTo = document.querySelector(SELECTORS.freeShippingValueTo);
          
          if (valueFrom) {
            valueFrom.textContent = utils.formatCurrency(current);
          }
          
          if (valueTo) {
            // Se o valor atual ultrapassou o valor necessário, mostrar o valor atual em ambos
            const displayValue = current >= target ? current : target;
            valueTo.textContent = utils.formatCurrency(displayValue);
          }
          
          // Atualizar o texto da dica baseado no progresso
          const tipElement = document.querySelector(SELECTORS.freeShippingTip);
          if (tipElement && (freeShippingLabel || freeShippingLabelSuccess)) {
            // Se alcançou ou ultrapassou o valor mínimo, mostrar mensagem de sucesso
            if (current >= target && freeShippingLabelSuccess) {
              tipElement.innerHTML = freeShippingLabelSuccess;
            } else if (freeShippingLabel) {
              // Senão, mostrar mensagem normal
              tipElement.innerHTML = freeShippingLabel;
            }
          }
        }
      };
  
      // Inicialização de eventos
      const initEvents = () => {
        const { SELECTORS } = CONFIG;
  
        $(document).on('click', '.shipping--value', e => {
          e.preventDefault();
          utils.toggleClasses([SELECTORS.shippingOverlay, SELECTORS.shipping], 'active');
        });
  
        const cartShippingClose = document.querySelector(SELECTORS.shippingClose);
        const cartShippingOverlay = document.querySelector(SELECTORS.shippingOverlay);
        if (cartShippingClose && cartShippingOverlay) {
          [cartShippingClose, cartShippingOverlay].forEach(el =>
            el.addEventListener('click', () =>
              utils.toggleClasses([SELECTORS.shippingOverlay, SELECTORS.shipping], 'active', false)
            )
          );
        }
  
        $(SELECTORS.shippingForm).on('submit', handleShippingSubmit);
        bindCouponEvents();
  
        bindAjaxComplete();
      };
  
      // Renderização de item do carrinho
      const renderCartItem = (item, deleteId) => {
        const brand = item.brand ? `<p class="cart-item-content-brand">${item.brand}</p>` : '';
        const price = utils.formatCurrency(item.unit_price);
        const variation = item.variation_value ? `<p class="cart-item-content-size">Tamanho: <b>${item.variation_value}</b></p>` : '';
        const giftClass = item.is_gift ? 'is-gift' : '';
  
        const el = document.createElement('li');
        el.className = `cart-item ${giftClass}`;
        el.setAttribute('data-product-id', item.id);
        el.innerHTML = `
          <figure><img src="${item.image_medium}" alt="${item.name}"></figure>
          <div class="cart-item-content">
            <div class="cart-item-content-header">
              <h4 class="cart-item-content-name">${item.name}</h4>
              <p class="cart-item-content-price">${price}</p>
            </div>
            <div class="group-content">
              <select class="variation-select" data-original-id="${item.original_id}">
                ${item.options.map(opt => `
                  <option 
                    value="${opt.product_id}" 
                    ${opt.product_id == item.original_id ? 'selected' : ''} 
                    ${!opt.available ? 'disabled' : ''}>
                      ${opt.value}
                  </option>
                `).join('')}
              </select>
              <div class="group-quantity">
                <button class="btn-decrease" data-product="${item.original_id}" data-qtd="${item.quantity}">-</button>
                <span class="qtd-value">${item.quantity}</span>
                <button class="btn-increase" data-product="${item.original_id}" data-qtd="${item.quantity}">+</button>
              </div>
              <button class="delete-item-button" data-original-id="${deleteId}"></button>
            </div>
            
          </div>
        `;
        return el;
      };
  
      // Atualização dos contadores
      const updateCartCounters = (count, total, discount) => {
        const { SELECTORS } = CONFIG;
        const subtotal = Number(total) + Number(discount);
  
        document.querySelectorAll(SELECTORS.counters).forEach(el => {
          el.textContent = String(count).padStart(2, '0');
        });
  
        const elSubtotal = document.querySelector(SELECTORS.subtotal);
        if (elSubtotal) {
          elSubtotal.textContent = utils.formatCurrency(subtotal);
        }
  
        const elDuscount = document.querySelector(SELECTORS.discounts);
        if (elDuscount) {
          elDuscount.textContent = utils.formatCurrency(discount);
        }
  
        document.querySelector(SELECTORS.total).textContent = utils.formatCurrency(total);
      };
  
      // Vinculação de eventos do carrinho
      const bindCartEvents = () => {
        document.querySelectorAll('.delete-item-button').forEach(btn => {
          btn.onclick = () => deleteCartItem(btn.dataset.originalId);
        });
  
        document.querySelectorAll('.btn-increase').forEach(btn => {
          btn.onclick = () => {
            const qtd = parseInt(btn.dataset.qtd);
            updateItemQuantity(btn.dataset.product, qtd + 1);
          };
        });
  
        document.querySelectorAll('.btn-decrease').forEach(btn => {
          btn.onclick = () => {
            const qtd = parseInt(btn.dataset.qtd);
            qtd > 1
              ? updateItemQuantity(btn.dataset.product, qtd - 1)
              : deleteCartItem(btn.dataset.product);
          };
        });
  
        document.querySelectorAll('.variation-select').forEach(select => {
          select.addEventListener('change', function () {
            const selectedOption = this.options[this.selectedIndex];
            const newProductId = selectedOption.value;
  
            const cartItemEl = this.closest('.cart-item-content');
            const currentQty = parseInt(cartItemEl.querySelector('.qtd-value')?.textContent || 1, 10);
  
            const cartItem = this.closest('.cart-item');
            const itemId = cartItem.classList.contains('is-gift') ? cartItem?.querySelector('.delete-item-button')?.getAttribute('data-original-id') : cartItem?.getAttribute('data-product-id');
            const currentProductId = cartItem.querySelector('select')?.getAttribute('data-original-id');
  
            if (!itemId || !currentProductId || !newProductId) {
              console.error('IDs insuficientes para processar troca de variação.');
              return;
            }
  
            const payload = [{
              addon_values: "[]",
              as_free: false,
              is_buying_by_measure: false,
              item_id: itemId,
              product: currentProductId,
              new_product: newProductId,
              quantity: currentQty,
              replace_quantity: true
            }];
  
            $.ajax({
              type: 'POST',
              url: '/api/front/cart/items/?version=2',
              headers: { 'Content-Type': 'application/json' },
              dataType: 'json',
              data: JSON.stringify(payload)
            }).done(function (data) {
              if (data && data.cart_data && data.result) {
                updateCartPreview(data);
                select.setAttribute('data-original-id', newProductId);
              }
            }).fail(function (jqXHR, textStatus, errorThrown) {
              console.error('Erro ao trocar variação:', errorThrown);
              alert('Erro ao trocar o tamanho do produto.');
            });
          });
        });
      };
  
      // Atualização da pré-visualização do carrinho
      const updateCartPreview = (data) => {
        const { SELECTORS } = CONFIG;
        const container = document.querySelector(SELECTORS.cartPreview);
        if (!container) return;
  
        const currentTotal = data.cart_data.total_without_shipping || data.cart_data.total;
        const freeShippingTarget = data.cart_data.free_shipping_target;
  
        // Esconde a barra de frete grátis se o target for '0' ou 0
        const freeShippingBar = document.querySelector('.cart-preview-free-shipping');
        if (freeShippingTarget === '0' || freeShippingTarget === 0) {
          if (freeShippingBar) freeShippingBar.style.display = 'none';
        } else if (freeShippingTarget) {
          if (freeShippingBar) freeShippingBar.style.display = '';
          utils.updateFreeShippingProgress(
            currentTotal,
            freeShippingTarget,
            data.cart_data.free_shipping_label,
            data.cart_data.free_shipping_label_success
          );
        }
  
        const list = container.querySelector(SELECTORS.itemsList);
        list.innerHTML = '';
  
        data.cart_data.items.forEach((item, index) => {
          const deleteId = data.result[index]?.id;
          list.appendChild(renderCartItem(item, deleteId));
        });
  
        updateCartCounters(data.result.length, data.cart_data.total, data.cart_data.total_discount);
        bindCartEvents();
  
        if (data.cart_data.coupon) {
          $(SELECTORS.couponInput).val(data.cart_data.coupon);
          $(SELECTORS.removeCoupon).addClass('active');
        }
  
  
  
        utils.updateFooterUtilsHeight(true);
      };
  
      // Recarregar pré-visualização
      const reloadCartPreview = () => {
        utils.ajaxRequest('GET', CONFIG.CART_ENDPOINT)
          .done(data => {
            if (data?.cart_data && data.result) {
              updateCartPreview(data);
            }
          });
      };
  
      // Remover item do carrinho
      const deleteCartItem = (id) => {
        utils.ajaxRequest('DELETE', '/api/front/cart/items/remove', [{ id }])
          .done(reloadCartPreview)
          .fail(err => console.log('Erro ao remover item do carrinho:', err));
      };
  
      // Atualizar quantidade do item
      const updateItemQuantity = (originalId, newQty) => {
        const payload = [{
          addon_values: "[]",
          as_free: false,
          is_buying_by_measure: false,
          product: originalId,
          quantity: newQty,
          replace_quantity: true,
        }];
  
        utils.ajaxRequest('POST', CONFIG.CART_ENDPOINT, payload)
          .done(data => {
            if (data?.cart_data && data.result) {
              updateCartPreview(data);
            }
          })
          .fail(jqXHR => {
            const data = jqXHR.responseJSON;
            if (Array.isArray(data) && data[0]?.stock) {
              alert(`O produto "${data[0].stock.product.name}" possui ${data[0].stock.quantity} unidade(s) em estoque.`);
            } else {
              alert('Ocorreu um erro inesperado ao atualizar a quantidade.');
            }
            console.log('Erro ao atualizar quantidade');
          });
      };
  
      // Vincular eventos de cupom
      const bindCouponEvents = () => {
        const { SELECTORS } = CONFIG;
  
        // Submit do cupom
        $('#js_form_coupon').on('submit', function (e) {
          e.preventDefault();
          const $form = $(this);
          const coupon = $form.find("input[name='coupon']").val();
  
          utils.ajaxRequest('PUT', '/api/front/cart/coupon/', { coupon })
            .done(() => {
              $(SELECTORS.removeCoupon).addClass('active');
              $form.removeClass('error').addClass('green').remove('invalid');
              // Recarregar a pré-visualização do carrinho para atualizar os valores
              reloadCartPreview();
            })
            .fail(() => {
              $form.removeClass('green').addClass('error').addClass('invalid');
            });
        });
  
        // Remoção do cupom
        $(SELECTORS.removeCoupon).on('click', function (e) {
          e.preventDefault();
          const $form = $('#js_form_coupon');
  
          utils.ajaxRequest('DELETE', '/api/front/cart/coupon/')
            .done(() => {
              $(SELECTORS.couponInput).val('');
              $(SELECTORS.removeCoupon).removeClass('active');
              $form.removeClass('green');
              reloadCartPreview();
            });
        });
  
        // Clique no input do cupom remove classes do form
        $('#js_form_coupon input[name="coupon"]').on('focus', function () {
          const $form = $('#js_form_coupon');
          $form.removeClass('green error invalid');
        });
  
      };
  
      // Manipular envio de frete
      const handleShippingSubmit = (e) => {
        e.preventDefault();
        const { SELECTORS } = CONFIG;
        const cep = $(SELECTORS.cepInput).val().replace(/['"]/g, ''); // Remove aspas simples ou duplas
        localStorage.setItem('cep', cep);
  
        const $loading = $('.shipping-loading');
        $loading.show();
  
        $.ajax({
          type: 'POST',
          url: '/produto/get-produto-frete/',
          data: { cep, show_delivery_shippings: true }, // Envia como form data, sem JSON
          dataType: 'json'
        }).done(data => {
          const shippings = data.shippings.shippings_available.shippings;
          const list = document.querySelector(SELECTORS.shippingList);
          if (!list) return;
  
          const hasMultiple = shippings.length > 1;
  
          const itemsHTML = shippings.map((s, i) => {
            let date = '';
            if (s.estimated_delivery_date != null && s.estimated_delivery_date !== '') {
              const [ano, mes, dia] = s.estimated_delivery_date.split('-');
              date = `${dia}/${mes}/${ano}`;
            }
            const cost = s.cost_label;
  
            return `
      <li class="cart-preview__shipping__list--item"
          data-index="${i}"
          data-shipping-id="${s.company_id}"
          data-shipping-cost="${cost}"
          data-shipping-name="${s.name}"
          data-shipping-price="${s.cost}"
          ${i > 0 ? 'style="display: none;"' : ''}>
        <div>
          <span>${s.name}</span>
          <span class="shipping--value">${cost}</span>
          <p>${s.delivery_time_days} ${s.label_delivery_time_days_checkout}</p>
          <p>Previsão ${date}</p>
        </div>
      </li>
    `;
          }).join('');
  
          const toggleBtn = hasMultiple
            ? `<button type="button" class="show-more-shippings" style="margin-top: 10px;">Ver mais opções de frete</button>`
            : '';
  
          list.innerHTML = itemsHTML + toggleBtn;
  
          requestAnimationFrame(() => {
            utils.updateFooterUtilsHeight(false);
          });
  
          if (hasMultiple) {
            const button = list.querySelector('.show-more-shippings');
            button?.addEventListener('click', () => {
              list.querySelectorAll('.cart-preview__shipping__list--item').forEach((li, i) => {
                if (i > 0) li.style.display = '';
              });
              button.style.display = 'none';
              utils.updateFooterUtilsHeight(false);
            });
          }
        })
          .fail(() => {
            alert('Erro ao calcular frete. Tente novamente.');
          })
          .always(() => {
            $loading.hide();
          });
  
      };
  
      // Vincular evento de conclusão de AJAX
      const bindAjaxComplete = () => {
        $(document).on("ajaxComplete", (event, xhr, settings) => {
          let payload = null;
  
          try {
            if (typeof settings.data === 'string') {
              payload = JSON.parse(settings.data);
            }
          } catch (err) {
            console.warn('settings.data não é um JSON válido:', settings.data);
            return; // early return para evitar seguir com payload inválido
          }
  
          const isReplacingQty = Array.isArray(payload) && payload[0]?.replace_quantity;
  
          if (
            settings.url.includes(CONFIG.CART_ENDPOINT) &&
            settings.type === 'POST' &&
            xhr.responseJSON?.result
          ) {
            reloadCartPreview();
            if (!isReplacingQty) {
              utils.toggleClasses(['.cart-preview--overlay'], 'active');
              utils.toggleClasses(['.cart-preview'], 'active');
              $('.shoppub-fast-buy-popup').removeClass('active');
              document.body.classList.toggle('no-scroll');
              document.documentElement.classList.toggle('no-scroll');
            }
          }
        });
      };
  
  
      // Inicialização
      reloadCartPreview();
      initEvents();
    },
  },
  mounted() {
    this.cartPreview();

    const allTitles = document.querySelectorAll('.cart-preview__footer-utils li');
    if (allTitles.length > 0) {
      allTitles.forEach(li => {
        const open = li.querySelector('.cart-preview__footer-utils--title');
        const toggleBtn = li.querySelector('.open-close');
        if (open && toggleBtn) {
          open.addEventListener('click', () => {
            li.classList.toggle('active');
            toggleBtn.classList.toggle('active');
          })
        }
      })
    }
  }
});

/* Dark and Light theme system */
/*function createTheme() {
    document.body.setAttribute('data-theme', localStorage.getItem('data-theme'));
    if (document.body.getAttribute('data-theme') == undefined) {
        document.body.setAttribute('data-theme', 'light')
        localStorage.setItem('data-theme', 'light')
    } else document.body.setAttribute('data-theme', localStorage.getItem('data-theme'));
}

createTheme();*/

/* Fix bug with slick on new product render (vitrine) */
const elementosLazy = document.querySelectorAll('.lazy-img');

elementosLazy.forEach(elemento => {
    const dataSrc = elemento.getAttribute('data-src');
    if (dataSrc) {
        elemento.setAttribute('src', dataSrc);
        elemento.removeAttribute('data-src');
    }
});

document.addEventListener("DOMContentLoaded", function() {
  /* duvidas-frequentes tab_accordion */
  var tabAccordions = document.querySelectorAll('.tab_accordion');
  var contentAccordions = document.querySelectorAll('.content_accordion');

  if (tabAccordions) {
    tabAccordions.forEach(function (tabAccordion, index) {
      tabAccordion.addEventListener('click', function () {
          tabAccordions.forEach(function (tab) {
              tab.classList.remove('active');
          });

          contentAccordions.forEach(function (content) {
              content.classList.remove('active');
          });
          
          tabAccordion.classList.add('active');
          contentAccordions[index].classList.add('active');
      });
    });
  }

  (function ($) {
    $.fn.visible = function (partial) {
  
      var $t = $(this),
        $w = $(window),
        viewTop = $w.scrollTop(),
        viewBottom = viewTop + $w.height(),
        _top = $t.offset().top,
        _bottom = _top + $t.height(),
        compareTop = partial === true ? _bottom : _top,
        compareBottom = partial === true ? _top : _bottom;
  
      return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
    };
  
  })(jQuery);
  
  function loadWidgets(event) {
  
    $(".product-item:not(.widget-loaded)").each(function (i, el) {
      var el = $(el);
      
      if (el.visible(true)) {
        el.addClass("widget-loaded");
        $(el).children().trigger("mouseenter");
    
        // Adicionando um timeout de 1s antes de mover os elementos
        setTimeout(function() {
          if (el.closest("#js_buy_together_api_layout_1").length) return;
          // Movendo .col-btn-add para dentro de .product-item__content--figure
          var btnAdd = el.find(".product-item__options .col-btn-add");
          var figure = el.find(".product-item__content--figure");
          if (btnAdd.length && figure.length) {
            figure.append(btnAdd);
          }
    
          // Adicionando evento de clique nos labels dentro de .product-radio-variation
          el.find(".product-radio-variation label").on("click", function() {
            var btnAdd = el.find(".col-btn-add");
            if (btnAdd.length) {
              btnAdd.addClass("active");
            }
          });
        }, 500); // Timeout de 1 segundo
      }
    });
    
  }
  
  $(window).scroll(loadWidgets);
  setTimeout(loadWidgets, 0);
});

/* Header Padding fix */
var page404Element = document.querySelector('.page-404');

if (page404Element) {
  page404Element.style.paddingTop = '133px';
  page404Element.style.setProperty('padding-top', '133px', 'important');
}

/* Name hover translate effect */
/*const figcaptionElements = document.querySelectorAll('.product-item__content--figcaption-name');

figcaptionElements.forEach((figcaption) => {
  const anchor = figcaption.querySelector('a');
  if (anchor) {
    const figcaptionWidth = figcaption.offsetWidth;
    const anchorWidth = anchor.offsetWidth;

    if (anchorWidth > figcaptionWidth) {
      figcaption.classList.add('action');
    }
  }
});*/

const figcaptionElements = document.querySelectorAll('.product-item__content--figcaption-name');

figcaptionElements.forEach((figcaption) => {
  const anchor = figcaption.querySelector('a');
  if (anchor) {
    const figcaptionWidth = figcaption.offsetWidth;
    const anchorWidth = anchor.offsetWidth;
    
    const transitionDuration = Math.max(1, Math.abs(anchorWidth - figcaptionWidth) / 100);

    if (anchorWidth > figcaptionWidth) {
      anchor.style.transition = `all ${transitionDuration}s linear`;
      figcaption.classList.add('action');
    }
  }
});


// cronômetro (home, categoria e detalhe)
(function () {
    function startStopwatch(stopwatchElement) {
        if (stopwatchElement.dataset.stopwatchInitialized) return;
        stopwatchElement.dataset.stopwatchInitialized = 'true';

        const dataInitStr = stopwatchElement.getAttribute('data-init');
        const dataEndStr = stopwatchElement.getAttribute('data-end');

        if (!dataInitStr || !dataEndStr) return;

        const dataInit = new Date(dataInitStr);
        const dataEnd = new Date(dataEndStr);

        if (isNaN(dataInit.getTime()) || isNaN(dataEnd.getTime())) return;

        const cronometroEl = stopwatchElement.querySelector('#cronometro');
        if (!cronometroEl) return;

        function formatarDigitos(numero) {
            return `<span>${numero.toString().padStart(2, '0')}</span>`;
        }

        let intervalo;

        function atualizar() {
            const agora = new Date().getTime();
            const initTimestamp = dataInit.getTime();
            const endTimestamp = dataEnd.getTime();

            let tempoRestante;
            let prefixo = '';

            if (agora < initTimestamp) {
                tempoRestante = initTimestamp - agora;
                prefixo = 'Inicia em ';
                stopwatchElement.classList.remove('active');
            } else if (agora < endTimestamp) {
                tempoRestante = endTimestamp - agora;
                stopwatchElement.classList.add('active');
            } else {
                cronometroEl.innerHTML = 'Tempo esgotado!';
                stopwatchElement.classList.remove('active');
                clearInterval(intervalo);
                return;
            }

            const dias = Math.floor(tempoRestante / (1000 * 60 * 60 * 24));
            const horas = Math.floor((tempoRestante % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutos = Math.floor((tempoRestante % (1000 * 60 * 60)) / (1000 * 60));
            const segundos = Math.floor((tempoRestante % (1000 * 60)) / 1000);

            cronometroEl.innerHTML = `<div>${prefixo}${formatarDigitos(dias)}d ${formatarDigitos(horas)}h ${formatarDigitos(minutos)}m ${formatarDigitos(segundos)}s</div>`;
        }

        // o .active muda sem scroll (início/fim da contagem): reavalia se fica fixo
        function atualizarComFixo() {
            atualizar();
            if (stopwatchElement.atualizarFixo) stopwatchElement.atualizarFixo();
        }

        intervalo = setInterval(atualizarComFixo, 1000);
        atualizarComFixo();
    }

    function mostrarAvisoCupom(cupom) {
        const avisoExistente = document.querySelector('.cupom-copiado-aviso');
        if (avisoExistente) avisoExistente.remove();

        const aviso = document.createElement('div');
        aviso.className = 'cupom-copiado-aviso';
        aviso.textContent = `Cupom ${cupom} copiado!`;
        aviso.style.cssText = `
    position: fixed;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    background: #000;
    color: #fff;
    padding: 12px 24px;
    border-radius: 4px;
    z-index: 9999;
    font-size: 14px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.2);
  `;

        document.body.appendChild(aviso);

        setTimeout(() => {
            aviso.remove();
        }, 3000);
    }

    function copiarFallback(texto) {
        const textarea = document.createElement('textarea');
        textarea.value = texto;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'absolute';
        textarea.style.left = '-9999px';
        document.body.appendChild(textarea);
        textarea.select();

        try {
            document.execCommand('copy');
            mostrarAvisoCupom(texto);
        } catch (err) {
            alert('Não foi possível copiar o cupom automaticamente. Cupom: ' + texto);
        }

        document.body.removeChild(textarea);
    }

    function initCupomCopy() {
        document.querySelectorAll('.stopwatch button[data-cupom]').forEach(button => {
            if (button.dataset.cupomInitialized) return;
            button.dataset.cupomInitialized = 'true';

            button.addEventListener('click', function () {
                const cupom = this.getAttribute('data-cupom');
                if (!cupom) return;

                if (navigator.clipboard && navigator.clipboard.writeText) {
                    navigator.clipboard.writeText(cupom)
                        .then(() => mostrarAvisoCupom(cupom))
                        .catch(() => copiarFallback(cupom));
                } else {
                    copiarFallback(cupom);
                }
            });
        });
    }

    // fixa o cronômetro logo abaixo do header ao rolar (html/body têm overflow-x hidden, sticky não funciona)
    function stickStopwatch(stopwatchElement) {
        if (stopwatchElement.dataset.stopwatchSticky) return;
        stopwatchElement.dataset.stopwatchSticky = 'true';

        // segura a posição e a altura original enquanto o cronômetro está fixo
        const placeholder = document.createElement('div');
        placeholder.className = 'stopwatch-placeholder';
        stopwatchElement.parentNode.insertBefore(placeholder, stopwatchElement);

        function atualizar() {
            const header = document.querySelector('#app_header');
            const headerHeight = header ? header.offsetHeight : 0;
            const fixo = stopwatchElement.classList.contains('active')
                && placeholder.getBoundingClientRect().top <= headerHeight;

            stopwatchElement.classList.toggle('stopwatch--fixed', fixo);
            stopwatchElement.style.top = fixo ? `${headerHeight}px` : '';
            placeholder.style.height = fixo ? `${stopwatchElement.offsetHeight}px` : '';
        }

        window.addEventListener('scroll', atualizar, { passive: true });
        window.addEventListener('resize', atualizar);
        window.addEventListener('load', atualizar);
        stopwatchElement.atualizarFixo = atualizar;
        atualizar();
    }

    function initStopwatches() {
        document.querySelectorAll('.stopwatch').forEach(startStopwatch);
        document.querySelectorAll('.stopwatch').forEach(stickStopwatch);
    }

    function initAll() {
        initStopwatches();
        initCupomCopy();
    }

    function observeChanges() {
        const observer = new MutationObserver(function () {
            initAll();
        });
        observer.observe(document.body, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            initAll();
            observeChanges();
        });
    } else {
        initAll();
        observeChanges();
    }
})();
